import React, { useState ,useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types';
import { fetchApp, showStatisticSummaries, setChartData } from '../store/actions/appAction'
import Menubar from '../components/Menubar';
import ReportSummary from '../components/report/ReportSummary';
import ReportTable from '../components/report/ReportTable';
import ReportChartLogin from '../components/report/ReportChartLogin';
import ReportChartSuccess from '../components/report/ReportChartSuccess';
import DateRangePicker from '../components/report/DateRangePicker';
import { Typography, Grid, Divider, Switch, TextField, Button, Accordion, AccordionSummary, AccordionDetails, Box,Tabs, Tab, AppBar, Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Moment from "moment"
import clsx from 'clsx';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  containerReport : {
    paddingTop: "7%",
    paddingLeft: "22%",
    backgroundColor: "#e8e8e8",
    paddingRight: "7%",
    paddingBottom: "14%",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "20%",
      paddingLeft: "5%",
      paddingRight: "5%",
      paddingBottom: "5%",
    },
  },
  gridReportSummary: {
    background: '#fff',
    padding: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033",
    paddingBottom: '0'
  },
  gridReportTable: {
    background: '#fff',
    padding: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033",
  },
  gridReportChart: {
    background: '#fff',
    padding: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033",
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
            <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}


const Report = () => {
    const dispatch = useDispatch()
    const classes = useStyles();
    const {id} = useParams()

    useEffect(() => {
      dispatch(fetchApp(id))
    }, [dispatch, id])

    const app = useSelector(state => state.appReducer.app)
    const statistics = useSelector(state => state.appReducer.statistics)
    const chartData = useSelector(state => state.appReducer.chartData)

    const [value, setValue] = React.useState(0);
    const [reportInput, setReportInput] = React.useState({
      startDate: Moment(new Date()).format('YYYY-MM-DD'),
      endDate: Moment(new Date()).add(1, 'days').format('YYYY-MM-DD'),
      categories: [],
      appId: id
    });
    const [timeFrameInput, setTimeFrameInput] = React.useState('daily');

    useEffect(() => {
      setReportInput({
        ...reportInput,
        startDate: Moment(app.createdAt).format('YYYY-MM-DD'),
      })
    }, [app])

    useEffect(() => {
      dispatch(showStatisticSummaries(reportInput))
    }, [dispatch, reportInput])

    useEffect(() => {
      const payload = {
        appId: reportInput.appId,
        startDate: reportInput.startDate,
        endDate: reportInput.endDate,
        categories: reportInput.categories,
        timeFrame: timeFrameInput,
      }
      dispatch(setChartData(payload))
    }, [dispatch, reportInput, timeFrameInput])

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const handleDateRange = (data) => {
      const date = data.split(" - ")
      const [ startDate, endDate ] = date
      const isValidDate = Moment(startDate, "DD-MMM-YYYY", true).isValid() && Moment(endDate, "DD-MMM-YYYY", true).isValid()
      if (isValidDate) {
        setReportInput({
          ...reportInput,
          startDate: Moment(startDate).format('YYYY-MM-DD'),
          endDate: Moment(endDate).add(1, 'days').format('YYYY-MM-DD')
        })
      } else {
        setReportInput({
          ...reportInput,
          startDate: Moment(app.createdAt).format('YYYY-MM-DD'),
          endDate: Moment(new Date()).add(1, 'days').format('YYYY-MM-DD')
        })
      }
    };

    const handleCategory = (data) => {
      setReportInput({
        ...reportInput,
        categories: data,
      })
    }

    const handleTimeFrame = (data) => {
      setTimeFrameInput(data)
    }

    return (
      <React.Fragment>
        <Menubar/>
        {
          statistics &&
          <Grid item xs={12} md={12} className={classes.containerReport}>
          {
            app.appName && 
            <Typography component="h1" variant="h5" align="center" color="textPrimary" spacing={4} gutterBottom className="mb-5">
              {`Report Page - ${app.appName}`}
            </Typography>
          }
          <div className='mb-10' style={{width:'200px', float: 'right'}}>
            <DateRangePicker dateRange={handleDateRange}/>
          </div>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Grid item xs={12} md={12} className={classes.gridReportSummary}>
                <TabPanel className="reportPageSummary" value={value} index={0}>
                  <ReportSummary overalStats={statistics.summaries} categorySelected={handleCategory}/>
                </TabPanel>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12} className="mt-20">
              <Grid item xs={12} md={12} className={classes.gridReportTable}>
                <TabPanel className="reportPageSummary" value={value} index={0}>
                  <ReportTable recentSignIn={statistics.recentSignIn}/>
                </TabPanel>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12} className="mt-20">
              <Grid item xs={12} md={12} className={classes.gridReportChart}>
                <TabPanel className="reportPageSummary" value={value} index={0}>
                  <ReportChartLogin chartData={chartData} timeFrameSelected={handleTimeFrame}/>
                </TabPanel>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12} className="mt-20">
              <Grid item xs={12} md={12} className={classes.gridReportChart}>
                <TabPanel className="reportPageSummary" value={value} index={0}>
                  <ReportChartSuccess chartData={chartData}/>
                </TabPanel>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        }
        <Divider/>
    </React.Fragment>
  )
}

export default Report
